import { inject, Injectable } from '@angular/core';
import { DataLoaderService } from './data-loader.service';
import { GOOGLE_API_KEY, GoogleApiService } from './google-api.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleContactsService {
  private googleApiService = inject(GoogleApiService);
  private loader = inject(DataLoaderService);

  private async connect() {
    return this.loader.get(
      'google-contacts-access-token',
      async () => {
        const SCOPES = 'https://www.googleapis.com/auth/contacts.readonly';
        const DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/people/v1/rest';
        await this.googleApiService.requestAccess(SCOPES, 'client');
        await window.gapi.client.init({
          apiKey: GOOGLE_API_KEY,
          discoveryDocs: [DISCOVERY_DOC],
        });
      },
      3600_000
    );
  }

  public async getConnections() {
    await this.connect();
    let response: {
      result: { connections: { names?: { displayName: string }[]; emailAddresses?: { value: string }[] }[] };
    };
    try {
      response = await window.gapi.client.people.people.connections.list({
        resourceName: 'people/me',
        pageSize: 10,
        personFields: 'names,emailAddresses',
      });
    } catch (err) {
      console.error(err);
      return;
    }
    return response.result.connections
      .filter(c => c.emailAddresses)
      .map(c => {
        return {
          name: c.names?.[0]?.displayName,
          email: c.emailAddresses?.[0]?.value,
        };
      });
  }
}
